import React from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DatePicker from "react-datepicker";
import { FiPlus, FiMinus } from "react-icons/fi";
import moment from "moment";
import SectionSeparator from "../SectionSeparator";

const ClinicInformationStep = ({ ctx }) => {
  const { addHealthDeclaration, chronicIllness, chronicIllnessDate, chronicIllnessDesc, chronicIllnesses, errors, formData, handleChange, health_declarations, removeHealthDeclaration, setChronicIllness, setChronicIllnessDate, setChronicIllnessDesc } = ctx;
  return <>
                <SectionSeparator title="title.medical_emergency" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_name">
                        {placeholder => <Form.Control value={formData.medical_emergency_name} placeholder={placeholder} type="text" name="medical_emergency_name" onChange={handleChange} />}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_doc">
                        {placeholder => <Form.Control value={formData.medical_emergency_doc} placeholder={placeholder} type="text" name="medical_emergency_doc" onChange={handleChange} />}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_clinic">
                        {placeholder => <Form.Control value={formData.medical_emergency_clinic} placeholder={placeholder} type="text" name="medical_emergency_clinic" onChange={handleChange} />}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="medical_emergency_phone">
                        {placeholder => <Form.Control value={formData.medical_emergency_phone} placeholder={placeholder} type="text" name="medical_emergency_phone" onChange={handleChange} />}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Chronic Illnesses */}
                <SectionSeparator title="title.health_declaration_form" />
                <Row>
                  <Col md={12}>
                    {" "}
                    <Form.Label>
                      <FormattedMessage id="chronic_illness" />
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select onChange={e => setChronicIllness(e.target.value)} value={chronicIllness} isInvalid={!!errors.chronicIllness}>
                        <option value="">
                          <FormattedMessage id="select" />
                        </option>
                        {chronicIllnesses.map((illness, index) => <option key={index} value={illness}>
                            {illness}
                          </option>)}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <FormattedMessage id="info_treatments_medications">
                      {placeholder => <Form.Control value={chronicIllnessDesc} placeholder={placeholder} type="text" onChange={e => setChronicIllnessDesc(e.target.value)} isInvalid={!!errors.chronicIllness} />}
                    </FormattedMessage>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="date">
                        {placeholder => <DatePicker placeholderText={placeholder} className={"form-control"} selected={chronicIllnessDate} onChange={date => setChronicIllnessDate(date)} isInvalid={!!errors.chronicIllness} />}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={1} className="ps-4">
                    <Button variant="success" size="sm" onClick={() => addHealthDeclaration("Chronic Illness")}>
                      <FiPlus />
                    </Button>
                  </Col>
                  <Col md={12}>
                    {errors.chronicIllness && <Form.Group className="mb-4 position-relative">
                        <Form.Control.Feedback className="px-3 d-block" type="invalid">
                          <FormattedMessage id="error.chronicIllness" />
                        </Form.Control.Feedback>
                      </Form.Group>}
                  </Col>
                </Row>

                {health_declarations.filter(healthDeclaration => healthDeclaration.child_health_type === "Chronic Illness").map((healthDeclaration, index) => <Row key={index} className="mb-3">
                      <Col md={3} className="ps-4">
                        {healthDeclaration.child_health_name}
                      </Col>
                      <Col md={5} className="ps-4">
                        {healthDeclaration.child_health_desc}
                      </Col>
                      <Col md={3} className="ps-4">
                        {moment(healthDeclaration.child_health_date).format("DD/MM/YYYY")}
                      </Col>
                      <Col md={1} className="ps-4">
                        <Button variant="danger" size="sm" onClick={() => removeHealthDeclaration(healthDeclaration.uuid)}>
                          <FiMinus />
                        </Button>
                      </Col>
                    </Row>)}

                <SectionSeparator title="title.bloodgroup" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="bloodgroup">
                        {placeholder => <Form.Control value={formData.bloodgroup} placeholder={placeholder} type="text" name="bloodgroup" onChange={handleChange} isInvalid={!!errors.bloodgroup} />}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.bloodgroup" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </>;
};

export default ClinicInformationStep;
